import log from 'loglevel';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './i18n';
import App from './App';
import store from './redux/store';
import './css/index.css';
import { DeletionStateProvider } from './MultiDeletionFunctionality/@state/DeletionStateContext';

ReactDOM.render(
  <Provider store={store}>
    <DeletionStateProvider>
      <App />
    </DeletionStateProvider>
  </Provider>,
  document.getElementById('root'),
);

if (process.env.NODE_ENV !== 'production') {
  log.enableAll();
}



// WEBPACK FOOTER //
// ./src/index.jsx